import React from "react";
import GovernanceLinkNav from "../components/GovernanceLinkNav";
import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import PdfPointer from "../components/PdfPointer";
import Footer from "../components/Footer";
import LinedLinks from "../components/Navigation/LinedLinks";

const CertificatesAndAccreditations = () => {
  const pdfs = [
    {
      label: "اعتماد ادارة المجلس من مركز التنمية",
      url: "pdfs/certificates_and_accreditations/council_management_approval_from_the_development_center.pdf",
      size: '307 KB'
    },
    {
      label: "ترخيص مركز الوطني لتنمية العمل غير الربحي",
      url: "pdfs/certificates_and_accreditations/license_of_the_national_center_for_the_development_of_non_profit_work.pdf",
      size: '45 KB'
    },
    {
      label: "قرار تعيين مجلس الادارة ",
      url: "pdfs/certificates_and_accreditations/appointment_of_the_majlis_e_adara.pdf",
      size: '87 KB'
    },
  ];
  return (
    <>
      <HeaderOriginal />
      <StickyNavBar />
      <section className="pb-4 md:pb-10 pt-4 md:pt-10">
        <div className="max-w-screen-xl mx-auto px-3">
          <h1 className="text-primary font-bold text-center mt-4">
            الشهادات والاعتمادات
          </h1>
          <LinedLinks link={'/certificates_and_accreditations'} label={'الشهادات والاعتمادات'}/>
          <div className="mt-8">
            {pdfs.map((pdf, index) => (
              <PdfPointer key={index}
                data={pdf}
              />
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CertificatesAndAccreditations;
